module.exports = __webpack_public_path__ + "4bf5f401cd050c63fa134ea1d1d7b176.png";